import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import NavItem from 'react-bootstrap/NavItem';
import cleanObject from 'utils/clean-object';
import CustomToggle from './CustomToggle';
import DropdownOptions from './DropdownOptions';
import styles from './ProductSortSelection.module.scss';

export default function ProductSortSelection({ sortOptions = [] }) {
  const router = useRouter();
  const [selectedSort, setSelectedSort] = useState(null);

  const { sort } = router.query;

  useEffect(() => {
    if (sortOptions && sortOptions?.length > 0) {
      const matchingOption = sortOptions.find(
        (options) => options.value === sort
      );
      const selectedOption = matchingOption ?? sortOptions[0];
      setSelectedSort(selectedOption);
    }
  }, [sort, sortOptions]);

  const onSelection = (selectedOption) => {
    if (selectedOption) {
      setSelectedSort(selectedOption);
      if (selectedOption.value !== sort) {
        router.push(
          {
            query: cleanObject({
              ...router.query,
              sort: selectedOption.value,
            }),
          },
          null,
          { shallow: true }
        );
      }
    }
  };

  return (
    <Col className="d-flex flex-column mx-0 font-roboto position-relative w-100">
      <Nav>
        <Dropdown as={NavItem} className="w-100">
          <Dropdown.Toggle
            as={CustomToggle}
            className="w-100"
            selectedSort={selectedSort}
          >
            {selectedSort}
          </Dropdown.Toggle>
          <Dropdown.Menu
            className={classNames('p-4 w-100', styles.dropDownmenu)}
          >
            <DropdownOptions
              selectedSort={selectedSort}
              sortOptions={sortOptions}
              onSelection={onSelection}
            />
          </Dropdown.Menu>
        </Dropdown>
      </Nav>
    </Col>
  );
}
